@if (isLoading) {
  <main class="flex min-h-[32rem] flex-1 items-center justify-center px-10 py-6 text-lWhite">
    <l-spinner />
  </main>
} @else if (course) {
  <div class="isolate">
    <div class="pointer-events-none absolute inset-x-0 top-0 h-[72vh] overflow-hidden">
      <img
        [src]="course.coverImageUrl"
        [alt]="course.title"
        class="h-full w-full object-cover object-center -z-20 opacity-95 mask-fade-bottom"
      >
      <div class="pointer-events-none absolute inset-x-0 top-0 h-60 bg-gradient-to-b from-lBgDark to-transparent"></div>
    </div>

    <main class="relative z-10 mt-24 flex flex-1 flex-col px-28 pb-12 text-lWhite">
    <section class="flex justify-between h-[40vh] items-end">
      <div class="flex items-center gap-3">
        <h1 class="text-4xl font-semibold tracking-tight md:text-6xl">{{ course.title }}</h1>

        <div class="flex items-center">
          <div class="w-10 h-9 pl-1 flex items-center justify-center rounded-l-full bg-lBlack text-lWhite">
            <l-icon class="text-lg">{{ locationIcon }}</l-icon>
          </div>

          <span class="px-3 py-2 rounded-r-full text-sm bg-lGray600 text-lWhite">
            {{ locationLabel }}
          </span>
        </div>
      </div>
      
      <button lButton [bRadius]="buttonRadiusEnum.LARGE" [bType]="buttonTypeEnum.PRIMARY" [bSize]="'medium'" class="!px-6" (click)="onButtonClick()">
        {{ buttonLabel }}
      </button>
    </section>

    <hr class="border-lWhite/10 my-12" />

    <section class="grid gap-8 px-6 py-8 lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.35fr)] lg:px-14">
      <div class="space-y-8">
        <div>
          <h2 class="text-2xl font-semibold text-lWhite">Descrição</h2>
          <p class="mt-4 max-w-xl text-base leading-7 text-lWhite/72">
            {{ course.description || 'Descrição indisponível no momento.' }}
          </p>
        </div>

        <div>
          <h2 class="text-2xl font-semibold text-lWhite">Detalhes do curso</h2>

          <div class="mt-4 space-y-4 text-lWhite/78">
            <div class="flex items-center gap-3 text-base">
              <l-icon class="text-lg text-lWhite/70">schedule</l-icon>
              <span>{{ durationLabel }}</span>
            </div>

            <div class="flex items-center gap-3 text-base">
              <l-icon class="text-lg text-lWhite/70">calendar_month</l-icon>
              <span>{{ course.createdAt | date:'dd/MM/yyyy' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h2 class="text-2xl font-semibold text-lWhite">Conteúdo de aprendizado</h2>

        <l-module-card [modules]="courseModules"></l-module-card>
      </div>
    </section>

    @if (isEnrolled) {
      <section class="mt-10">
        <l-progress-banner [progress]="userCourseProgress" />
      </section>
    }
    
    </main>
  </div>
} @else {
  <main class="flex min-h-[520px] flex-1 flex-col items-center justify-center px-10 py-6 text-center text-lWhite">
    <h1 class="text-3xl font-semibold">Curso não encontrado</h1>
    <p class="mt-3 max-w-md text-lWhite/70">
      Não foi possível localizar os dados do curso solicitado a partir do identificador informado na URL.
    </p>
    <a routerLink="/courses" lButton [bRadius]="buttonRadiusEnum.LARGE" [bType]="buttonTypeEnum.BASIC" class="mt-8 px-6">
      Voltar para cursos
    </a>
  </main>
}